import React from 'react';
import { SvgIcon } from './svg-icon';

export const ArrowRight2 = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M8.59 7.41L13.17 12L8.59 16.59L10 18L16 12L10 6L8.59 7.41Z" />
  </SvgIcon>
);
